import aa from 'search-insights';
import { globals } from './globals';
export const handleAlgoliaClickEvent = (queryID: string, eventName: string, sendEvent: any, hit: any) => {
  // Set the queryID in localStorage
  localStorage.setItem('queryID', queryID);

  // Call the sendEvent function
  sendEvent('click', hit, eventName);
};

export const handleAlgoliaAddToCartEvent = (queryID: string, eventName: string, itemCode: string) => {
  aa('convertedObjectIDsAfterSearch', {
    eventName,
    index: `${globals.algoliaIndexName}`,
    queryID,
    objectIDs: [itemCode],
  });
};


/**
 * Handles the non-search "Add to Cart" event.
 * 
 * @param eventName - The name of the event.
 * @param itemCode - The code of the item.
 * @param addPath - Optional. Whether to include the current path in the event name. Default is false.
 */
export const handleNonSearchAddToCartEvent = (eventName: string, itemCode: string, addPath = false) => {
  const path = window.location.pathname;
  let updatedEventName = eventName;
  if (addPath) {
    updatedEventName = `${eventName} - ${path}`;
  }
  aa('convertedObjectIDs', {
    eventName: updatedEventName,
    index: `${globals.algoliaIndexName}`,
    objectIDs: [itemCode],
  });
};

/**
 * Handles non-search click events by tracking them with Algolia.
 * @param eventName - The name of the event.
 * @param itemCode - The code of the item being clicked.
 * @param addPath - Optional parameter to include the current path in the event name.
 */
export const handleNonSearchClickEvent = (eventName: string, itemCode: string, addPath = false) => {
  const path = window.location.pathname;
  let updatedEventName = eventName;
  if (addPath) {
    updatedEventName = `${eventName} - ${path}`;
  }
  aa('clickedObjectIDs', {
    eventName: updatedEventName,
    index: `${globals.algoliaIndexName}`,
    objectIDs: [itemCode],
  });
};
